import { BadgeConfig, KpiHealthEnum, MilestoneStatusEnum, PortfolioMilestoneStatus } from '@models';

const BADGES_COLORS = {
  gray: { textColor: '#2B2B30', backgroundColor: '#E5E5E5', iconColor: '#2B2B30' },
  green: { textColor: '#005512', backgroundColor: '#D9FBE2', iconColor: '#005512' },
  red: { textColor: '#790000', backgroundColor: '#FDE4E4', iconColor: '#790000' },
  orange: { textColor: '#6C2501', backgroundColor: '#FFEBD6', iconColor: '#6C2501' },
  blue: { textColor: '#00399C', backgroundColor: '#DFEEFF', iconColor: '#00399C' },
  medium_green: { textColor: '#005512', backgroundColor: '#D9FBE2', iconColor: '#01891E' },
  transparent_blue_text: { textColor: 'blue', backgroundColor: null, iconColor: '#00399C' },
  transparent_red_text: { textColor: 'red', backgroundColor: null, iconColor: '#790000' },
  transparent_gray_text: { textColor: 'gray', backgroundColor: null, iconColor: '#2B2B30' },
  transparent_green_text: { textColor: 'green', backgroundColor: null, iconColor: '#005512' }
};

const NO_THRESHOLD_BADGE_CONFIG: BadgeConfig = {
  label: 'No threshold defined',
  icon: 'forbidden-bold',
  ...BADGES_COLORS.gray
};
const KPI_HEALTH_BADGES: Record<KpiHealthEnum, BadgeConfig> = {
  ['on-target']: {
    label: 'On track',
    icon: 'like',
    ...BADGES_COLORS.green
  },
  ['off-target']: {
    label: 'Off track',
    icon: 'exclamation-circle-bold',
    ...BADGES_COLORS.red
  },
  ['at-risk']: {
    label: 'At risk',
    icon: 'warning-bold',
    ...BADGES_COLORS.orange
  },
  ['completed']: {
    label: 'Complete',
    icon: 'checked-circle-bold',
    ...BADGES_COLORS.blue
  },
  ['no-threshold']: NO_THRESHOLD_BADGE_CONFIG,
  ['no-data']: NO_THRESHOLD_BADGE_CONFIG
};

const PORTFOLIO_MILESTONE_BADGES: Partial<Record<PortfolioMilestoneStatus, BadgeConfig>> = {
  ['Upcoming']: {
    label: 'Upcoming',
    icon: 'arrow-right-circle',
    ...BADGES_COLORS.gray
  },
  ['On Track']: {
    label: 'On track',
    icon: 'like',
    ...BADGES_COLORS.medium_green
  },
  ['At Risk']: {
    label: 'At risk',
    icon: 'warning-bold',
    ...BADGES_COLORS.orange
  },
  ['Past Due']: {
    label: 'Past due',
    icon: 'exclamation-circle-bold',
    ...BADGES_COLORS.red
  },
  ['Dates Not Available']: {
    label: 'Dates not available',
    icon: null,
    ...BADGES_COLORS.gray
  }
};

const STUDY_MILESTONE_BADGES: Record<MilestoneStatusEnum, BadgeConfig> = {
  ['Completed']: {
    label: 'Completed | Timing unknown',
    icon: 'checked-circle-bold',
    ...BADGES_COLORS.transparent_blue_text
  },
  ['Completed | Accelerated']: {
    label: 'Completed | Accelerated',
    icon: 'checked-circle-bold',
    ...BADGES_COLORS.transparent_blue_text
  },
  ['Completed | On Time']: {
    label: 'Completed | On time',
    icon: 'checked-circle-bold',
    ...BADGES_COLORS.transparent_blue_text
  },
  ['Completed | Late']: {
    label: 'Completed | Late',
    icon: 'checked-circle-bold',
    ...BADGES_COLORS.transparent_blue_text
  },
  ['Past Due']: {
    label: 'Past due',
    icon: 'exclamation-circle-bold',
    ...BADGES_COLORS.transparent_red_text
  },

  ['Upcoming']: {
    label: 'Upcoming',
    icon: 'arrow-right-circle',
    ...BADGES_COLORS.transparent_gray_text
  },
  ['On Track']: {
    label: 'On track',
    icon: 'like',
    ...BADGES_COLORS.transparent_green_text
  },
  ['At Risk']: {
    label: 'At risk',
    icon: 'warning-bold',
    ...BADGES_COLORS.orange
  }
};

const PORTFOLIO_MILESTONES_BADGES: Record<MilestoneStatusEnum, BadgeConfig> = {
  ['Completed']: {
    label: 'Completed',
    icon: 'checked-circle-bold',
    ...BADGES_COLORS.transparent_blue_text
  },
  ['Completed | Accelerated']: {
    label: 'Completed | Accelerated',
    icon: 'checked-circle-bold',
    ...BADGES_COLORS.transparent_blue_text
  },
  ['Completed | On Time']: {
    label: 'Completed | On time',
    icon: 'checked-circle-bold',
    ...BADGES_COLORS.transparent_blue_text
  },
  ['Completed | Late']: {
    label: 'Completed | Late',
    icon: 'checked-circle-bold',
    ...BADGES_COLORS.transparent_blue_text
  },
  ['Past Due']: {
    label: 'Past due',
    icon: 'exclamation-circle-bold',
    ...BADGES_COLORS.transparent_red_text
  },

  ['Upcoming']: {
    label: 'Upcoming',
    icon: 'arrow-right-circle',
    ...BADGES_COLORS.transparent_gray_text
  },
  ['On Track']: {
    label: 'On track',
    icon: 'like',
    ...BADGES_COLORS.transparent_green_text
  },
  ['At Risk']: {
    label: 'At risk',
    icon: 'warning-bold',
    ...BADGES_COLORS.orange
  }
};

export {
  BADGES_COLORS,
  KPI_HEALTH_BADGES,
  PORTFOLIO_MILESTONE_BADGES,
  PORTFOLIO_MILESTONES_BADGES,
  STUDY_MILESTONE_BADGES
};
